var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResumesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 147,
    viewBox: "0 0 110 147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    transform: "translate(0 1) translate(18.629 13.366)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D4E9F8",
    d: "M8.476 9.386L15.947.493h71.31c1.659 0 3.004 1.345 3.004 3.005v125.404c0 1.66-1.345 3.005-3.005 3.005H3.52c-1.66 0-3.005-1.346-3.005-3.005V15.992l7.568-6.217c.143-.117.274-.248.393-.39z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.124,
    height: 2.602,
    x: 10.131,
    y: 26.738,
    fill: "#0E83EB",
    rx: 1.301
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.244,
    height: 2.602,
    x: 10.131,
    y: 39.746,
    fill: "#0E83EB",
    rx: 1.301
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.515,
    height: 2.602,
    x: 10.131,
    y: 47.551,
    fill: "#0E83EB",
    rx: 1.301
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.244,
    height: 2.602,
    x: 10.131,
    y: 65.763,
    fill: "#0E83EB",
    rx: 1.301
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.244,
    height: 2.602,
    x: 10.131,
    y: 73.568,
    fill: "#0E83EB",
    rx: 1.301
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.515,
    height: 2.602,
    x: 10.131,
    y: 81.372,
    fill: "#0E83EB",
    rx: 1.301
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.515,
    height: 2.602,
    x: 10.131,
    y: 89.177,
    fill: "#0E83EB",
    rx: 1.301
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.983,
    height: 2.602,
    x: 9.621,
    y: 107.16,
    fill: "#0E83EB",
    rx: 1.301
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.562,
    height: 2.602,
    x: 9.621,
    y: 114.965,
    fill: "#0E83EB",
    rx: 1.301
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0C2E5",
    d: "M15.968.49v11.801c0 2.021-1.638 3.659-3.659 3.659H.515L15.968.49z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#09143B",
    strokeWidth: 2,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.115 9L13.358.243M13.408 24.942L1.392 25.058M15.816 16.808L1.988 8.987",
    transform: "translate(0 1)"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#3C4A66",
    fontFamily: "ProximaNova-Semibold, Proxima Nova",
    fontSize: 40,
    fontWeight: 500,
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 55.34,
    y: 92
  }, "?")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResumesIcon);
export default __webpack_public_path__ + "static/media/no-resumes-icon.162862ae35ac358b571bc43c87831ee6.svg";
export { ForwardRef as ReactComponent };